export const createSessionRefreshCoordinator = ({
	refresh,
	onSuccess = () => {},
	onFailure = () => {}
}) => {
	let inFlight = null;

	return () => {
		if (!inFlight) {
			inFlight = Promise.resolve()
				.then(refresh)
				.then(result => {
					onSuccess(result);
					return result;
				})
				.catch(error => {
					onFailure(error);
					throw error;
				})
				.finally(() => {
					inFlight = null;
				});
		}

		return inFlight;
	};
};
